export const generateSchemaOrg = (language) => {
  const baseUrl = 'https://file.heliar.top/';
  
  const schemaConfigs = {
    'zh-CN': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation 文件托管平台",
        "url": baseUrl,
        "description": "FileStation是一个现代化的文件托管平台，支持图片、视频、文档等多种文件格式的快速上传和分享。提供免费的云存储服务，支持取件码保护，文件自动过期管理，安全可靠。",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "zh-CN"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "CNY"
        },
        "description": "FileStation是一个现代化的文件托管平台，支持图片、视频、文档等多种文件格式的快速上传和分享。提供免费的云存储服务，支持取件码保护，文件自动过期管理，安全可靠。",
        "featureList": [
          "文件上传",
          "文件分享",
          "取件码保护",
          "文件过期管理",
          "多格式支持",
          "批量上传",
          "云存储"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "zh-CN"
      }
    },
    'en-US': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation File Hosting Platform",
        "url": baseUrl,
        "description": "FileStation is a modern file hosting platform supporting fast upload and sharing of images, videos, documents, and more. Provides free cloud storage with pickup code protection, automatic file expiration management, secure and reliable.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "en-US"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        },
        "description": "FileStation is a modern file hosting platform supporting fast upload and sharing of images, videos, documents, and more. Provides free cloud storage with pickup code protection, automatic file expiration management, secure and reliable.",
        "featureList": [
          "File Upload",
          "File Sharing",
          "Pickup Code Protection",
          "File Expiration Management",
          "Multi-format Support",
          "Batch Upload",
          "Cloud Storage"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "en-US"
      }
    },
    'ja-JP': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation ファイルホスティングプラットフォーム",
        "url": baseUrl,
        "description": "FileStationは画像、動画、ドキュメントなど、様々なファイル形式の高速アップロードと共有をサポートするモダンなファイルホスティングプラットフォームです。無料のクラウドストレージを提供し、ピックアップコードによる保護、自動有効期限管理、安全で信頼性の高いサービスです。",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "ja-JP"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "JPY"
        },
        "description": "FileStationは画像、動画、ドキュメントなど、様々なファイル形式の高速アップロードと共有をサポートするモダンなファイルホスティングプラットフォームです。無料のクラウドストレージを提供し、ピックアップコードによる保護、自動有効期限管理、安全で信頼性の高いサービスです。",
        "featureList": [
          "ファイルアップロード",
          "ファイル共有",
          "ピックアップコード保護",
          "有効期限管理",
          "マルチフォーマット対応",
          "一括アップロード",
          "クラウドストレージ"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "ja-JP"
      }
    },
    'ko-KR': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation 파일 호스팅 플랫폼",
        "url": baseUrl,
        "description": "FileStation은 이미지, 비디오, 문서 등 다양한 파일 형식의 빠른 업로드와 공유를 지원하는 현대적인 파일 호스팅 플랫폼입니다. 무료 클라우드 스토리지를 제공하며, 픽업 코드 보호, 자동 만료 관리, 안전하고 신뢰할 수 있는 서비스를 제공합니다.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "ko-KR"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "KRW"
        },
        "description": "FileStation은 이미지, 비디오, 문서 등 다양한 파일 형식의 빠른 업로드와 공유를 지원하는 현대적인 파일 호스팅 플랫폼입니다. 무료 클라우드 스토리지를 제공하며, 픽업 코드 보호, 자동 만료 관리, 안전하고 신뢰할 수 있는 서비스를 제공합니다.",
        "featureList": [
          "파일 업로드",
          "파일 공유",
          "픽업 코드 보호",
          "만료 관리",
          "다중 형식 지원",
          "일괄 업로드",
          "클라우드 스토리지"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "ko-KR"
      }
    },
    'fr-FR': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation Plateforme d'hébergement de fichiers",
        "url": baseUrl,
        "description": "FileStation est une plateforme d'hébergement de fichiers moderne supportant le téléchargement rapide et le partage d'images, de vidéos, de documents et plus. Fournit un stockage cloud gratuit avec protection par code de retrait, gestion automatique de l'expiration des fichiers, sécurisé et fiable.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "fr-FR"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "EUR"
        },
        "description": "FileStation est une plateforme d'hébergement de fichiers moderne supportant le téléchargement rapide et le partage d'images, de vidéos, de documents et plus. Fournit un stockage cloud gratuit avec protection par code de retrait, gestion automatique de l'expiration des fichiers, sécurisé et fiable.",
        "featureList": [
          "Téléchargement de fichiers",
          "Partage de fichiers",
          "Protection par code de retrait",
          "Gestion de l'expiration",
          "Support multi-format",
          "Téléchargement en lot",
          "Stockage cloud"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "fr-FR"
      }
    },
    'de-DE': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation Datei-Hosting-Plattform",
        "url": baseUrl,
        "description": "FileStation ist eine moderne Datei-Hosting-Plattform, die schnellen Upload und Freigabe von Bildern, Videos, Dokumenten und mehr unterstützt. Bietet kostenlosen Cloud-Speicher mit Abholcode-Schutz, automatischer Ablaufverwaltung von Dateien, sicher und zuverlässig.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "de-DE"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "EUR"
        },
        "description": "FileStation ist eine moderne Datei-Hosting-Plattform, die schnellen Upload und Freigabe von Bildern, Videos, Dokumenten und mehr unterstützt. Bietet kostenlosen Cloud-Speicher mit Abholcode-Schutz, automatischer Ablaufverwaltung von Dateien, sicher und zuverlässig.",
        "featureList": [
          "Datei-Upload",
          "Datei-Freigabe",
          "Abholcode-Schutz",
          "Ablaufverwaltung",
          "Multi-Format-Unterstützung",
          "Batch-Upload",
          "Cloud-Speicher"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "de-DE"
      }
    },
    'es-ES': {
      webSite: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "FileStation",
        "alternateName": "FileStation Plataforma de alojamiento de archivos",
        "url": baseUrl,
        "description": "FileStation es una plataforma moderna de alojamiento de archivos que admite la subida rápida y el intercambio de imágenes, videos, documentos y más. Proporciona almacenamiento en la nube gratuito con protección por código de recogida, gestión automática de caducidad de archivos, seguro y fiable.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": baseUrl + "?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "publisher": {
          "@type": "Organization",
          "name": "FileStation",
          "url": baseUrl
        },
        "inLanguage": "es-ES"
      },
      softwareApplication: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "FileStation",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "EUR"
        },
        "description": "FileStation es una plataforma moderna de alojamiento de archivos que admite la subida rápida y el intercambio de imágenes, videos, documentos y más. Proporciona almacenamiento en la nube gratuito con protección por código de recogida, gestión automática de caducidad de archivos, seguro y fiable.",
        "featureList": [
          "Subida de archivos",
          "Compartir archivos",
          "Protección por código de recogida",
          "Gestión de caducidad",
          "Soporte multi-formato",
          "Subida por lotes",
          "Almacenamiento en la nube"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1000"
        },
        "inLanguage": "es-ES"
      }
    }
  };

  return schemaConfigs[language] || schemaConfigs['zh-CN'];
}